export default __webpack_public_path__ + "static/media/server1.dee826a9.jpeg";